<div class="overlay">

    <header class="fixing customheader" [ngClass]="{open: openVisible}">
        <!-- <header class="" [ngClass]="{open: openVisible,fixing:visibilitycustomOpen,customheader:visibilitycustomOpen}"> -->
        <a href="./home">
            <img src="./assets/img/ros_logo.png" alt="" width="100%;">
        </a>
        <div class="nav-icon " (click)="openVisible=!openVisible">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <nav class="desktop p-1">
            <!-- <div [@listAnimation]="listTitles.length" (@listAnimation.start)="logAnimation($event)" (@listAnimation.done)="logAnimation($event)"> -->
            <ul *ngIf="openVisible" [@slideOutIn]>
                <li *ngFor="let menuItem of listTitles" class="menulist" [ngClass]="{'active':menuItem.nav_path === temppath}">
                    <a href="{{menuItem.nav_path}}" class="{{menuItem.nav_class}}" (click)="changePath(menuItem.nav_path)" *ngIf="menuItem.nav_status === '1'">
                        <i class="{{menuItem.nav_icon}}"></i> {{menuItem.nav_name}}
                    </a>
                </li>
                <!-- [ngClass]="{'active': temppath}" -->
                <!-- <li class="menulist" *ngIf="visibleMenu">
                    <a href="./login">
                    Login
                  </a>
                </li> -->
                <li class="menulist" *ngIf="!visibleMenu">
                    <a href="./document">
                    Documents
                  </a>
                </li>
                <li class="menulist" *ngIf="!visibleMenu">
                    <a href="./projects">
                        Projects
                    </a>
                </li>
                    <li class="menulist" *ngIf="!visibleMenu">
                        <div class="dropdown">
                            <a class="dropbtn">
                                <!-- <i class="fa fa-user"></i> -->
                                Settings
                            </a>
                            <div class="dropdown-content">
                                <a href="/profile">
                                    {{userName}}
                                </a>
                                <!-- <a href="#">Change Password</a> -->
                                <!-- <a href="#">Link 3</a> -->
                            </div>
                        </div>
                    </li>
                 <!-- <li class="menulist" *ngIf="!visibleMenu">
                    <a href="./home" (click)="logout()">
                    Logout
                  </a>
                </li>  -->
            </ul>
            <!-- </div> -->
        </nav>

        <!-- mobile -->
        <!-- (click)="changePath(menuItem.nav_path);close()" href="{{menuItem.nav_path}}" -->
        <nav class="mobile">
            <!-- <div [@listAnimation]="listTitles.length" (@listAnimation.start)="logAnimation($event)" (@listAnimation.done)="logAnimation($event)"> -->
            <ul *ngIf="openVisible" [@slideInOut]>
                <!-- [ngClass]="{'active':menuItem.nav_path === temppath }" [ngClass]="{'active':menuItem.nav_path === temppath }" class="{{menuItem.nav_class}} menulist" *ngIf="menuItem.nav_status === '1' && !(menuItem.nav_name === 'About us') && !(menuItem.nav_name === 'Engineering Solutions') &&
                    !(menuItem.nav_name === 'Videos') && !(menuItem.nav_name === 'Career')"-->
                <li *ngFor="let menuItem of listTitles" class="" >
                   <a href="{{menuItem.nav_path}}" *ngIf="menuItem.nav_status === '1'">
                    <span >
                        {{menuItem.nav_name}}
                    </span>
                </a>
                <span class="down_icon" (click)="opensub(menuItem.nav_name)" *ngIf="menuItem.nav_name === 'About us' || menuItem.nav_name === 'Videos' 
                || menuItem.nav_name === 'Engineering Solutions' || menuItem.nav_name === 'Safety'">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
            </span>

                    <ul [hidden]="show" *ngIf="menuItem.nav_name === 'About us' && sub_nav === menuItem.nav_name">
                        <li class="submenu"  *ngFor="let list of aboutMenus">
                            <a href="about-us/{{list.about_path}}"  class=" "> {{list.about_title}}</a>
                        </li>
                    </ul>
                    <ul [hidden]="show" *ngIf="menuItem.nav_name === 'Engineering Solutions' && sub_nav === menuItem.nav_name">
                        <li class="submenu"  *ngFor="let list of enggMenus">
                            <a href="engineering-solutions/{{list.engg_path}}" class="" > {{list.engg_name}}</a>
                        </li>
                    </ul>
                    <ul [hidden]="show" *ngIf="menuItem.nav_name === 'Videos' && sub_nav === menuItem.nav_name">
                         <li class="submenu " *ngFor="let list of projectMenu">
                            <a  class=" "  href="videos/{{list.project_path}}"  *ngIf="list.project_status === '1'" >
                                {{list.project_title}}</a>
                        </li> 
                    </ul>
                    <ul [hidden]="show" *ngIf="menuItem.nav_name === 'Safety' && sub_nav === menuItem.nav_name">
                        <li class="submenu " >
                           <a  class=" "  href="safety/safe">
                              Safety</a>
                       </li> 
                       <li class="submenu ">
                        <a  class=" "  href="safety/safecomp">
                            Certificate</a>
                       </li>
                   </ul>               
                </li>
                <!-- [ngClass]="{'active': temppath}" -->
                <!-- <li class="menulist" *ngIf="visibleMenu">
                    <a href="./login">
                    Login
                  </a>
                </li> -->
                <li class="menulist" *ngIf="!visibleMenu">
                    <a href="./document">
                    Documents
                  </a>
                  <span class="down_icon" (click)="opensub('Documents')"  >
                    <i class="fa fa-angle-down" aria-hidden="true"></i> 
                </span>
                <ul [hidden]="show" *ngIf="sub_nav === 'Documents'"  >
                    <li class="submenu"><a  class=" " *ngFor="let menu of docmenu"  href="document/{{menu.docs_route}}">{{menu.docs_name}}</a></li> 
                </ul> 
                </li>
                <li class="menulist" *ngIf="!visibleMenu">
                    <a href="./projects">
                        Projects
                    </a>
                </li>
                <li class="menulist" *ngIf="!visibleMenu">
                    <div class="dropdown">
                        <button class="dropbtn">
                            Settings
                            <!-- <i class="fa fa-user"></i> -->
                        </button>
                        <div class="dropdown-content">
                            <a href="/profile">
                                {{userName}}
                            </a>
                            <!-- <a href="#">Change Password</a> -->
                            <!-- <a href="#">Link 3</a> -->
                        </div>
                    </div>
                </li>
                <li class="menulist" *ngIf="!visibleMenu">
                    <a href="./home" (click)="logout()">
                    Logout
                  </a>
                </li>
            </ul>
            <!-- </div> -->
        </nav>
    </header>

</div>